/**
 * Shorten a name for a control whose width is set by its content.
 *
 * Menus size themselves to their longest row, so a collection called
 * "Marine Microplastics Biodegradation Assay" stretched both the create
 * menu's group headings ("CAPTURE INTO <name>") and the sidebar's
 * "Add to <name>" until they ran off the panel.
 *
 * Truncates on a WORD boundary where one is close enough to the limit, so
 * "Marine Microplastics Biodegradation…" beats "Marine Microplastics Biodegrada…".
 * Falls back to a hard cut when a single word is longer than the limit.
 *
 * The ellipsis is the single character U+2026, not three dots: screen readers
 * announce "…" as a pause rather than reading "dot dot dot".
 *
 * NEVER use this for an accessible name — truncating an aria-label hides the
 * end of the very string assistive tech depends on. Pass the full name there
 * and the truncated one to the visible node.
 */
export function truncateName(name: string, maxLength = 28): string {
  const trimmed = name.trim();
  if (trimmed.length <= maxLength) return trimmed;

  const hardCut = trimmed.slice(0, maxLength);
  const lastSpace = hardCut.lastIndexOf(' ');
  // Only prefer the word boundary when it isn't throwing away most of the
  // budget — otherwise a long first word leaves a uselessly short label.
  const cut = lastSpace >= maxLength * 0.6 ? hardCut.slice(0, lastSpace) : hardCut;
  return `${cut.trimEnd()}…`;
}
